import angular from 'angular'

// components
import manageTeams from './component/manageTeams.component.js'

export default angular
  .module('portalApp.manage.teams', [])
  .component('manageTeams', manageTeams)
  .name
